import { AbstractEvent } from './AbstractEvent';

export class PurchasedAfterSearch extends AbstractEvent {
  algoliaEvent = 'purchasedObjectIDsAfterSearch';

  customEventName = 'purchased_after_search';
}
